// import React from "react";
// import { Box, Typography, Button, Zoom } from "@mui/material";
// import { styled, keyframes } from "@mui/material/styles";
// import { Link } from "react-router-dom";

// const shimmer = keyframes`
//   0% { background-position: -1000px 0; }
//   100% { background-position: 1000px 0; }
// `;
// const GradientText = styled("span")(({ theme }) => ({
//   background: "linear-gradient(135deg, #2E9E53 0%, #45B7A0 50%, #0B4064 100%)",
//   WebkitBackgroundClip: "text",
//   WebkitTextFillColor: "transparent",
//   fontWeight: "inherit",
//   backgroundSize: "200% 200%",
//   animation: `${shimmer} 3s ease-in-out infinite`,
// }));

// const Hero = () => {
//   const scrollToSection = (href) => {
//     const element = document.querySelector(href);
//     if (element) {
//       element.scrollIntoView({ behavior: "smooth" });
//     }
//   };

//   return (
//     <Box
//       component="section"
//       className="hero"
//       sx={{
//         marginTop: "80px",
//         minHeight: "90vh",
//         display: "flex",
//         alignItems: "center",
//         position: "relative",
//         overflow: "hidden",
//         background: "linear-gradient(135deg, #F7F7F7 0%, #E8F4F8 100%)",
//         "&::before": {
//           content: '""',
//           position: "absolute",
//           width: { xs: "300px", md: "600px" },
//           height: { xs: "300px", md: "600px" },
//           background:
//             "radial-gradient(circle, rgba(255, 107, 53, 0.1) 0%, transparent 70%)",
//           top: "-100px",
//           right: "-100px",
//           borderRadius: "50%",
//         },
//       }}
//     >
//       <Box
//         className="hero-content"
//         sx={{
//           width: "100%",
//           maxWidth: "1400px",
//           margin: "0 auto",
//           padding: { xs: "2rem 1.25rem", sm: "3rem 2rem", lg: "4rem 2rem" },
//           display: "grid",
//           gridTemplateColumns: { xs: "1fr", lg: "1.2fr 1fr" },
//           gap: { xs: "2.5rem", md: "4rem" },
//           alignItems: "center",
//           boxSizing: "border-box",
//         }}
//       >
//         {/* ── Text block ─────────────────────────────────────────────── */}
//         <Box
//           className="hero-text"
//           sx={{
//             textAlign: { xs: "center", lg: "left" },
//           }}
//         >
//           <Zoom in timeout={1000}>
//             <Typography
//               component="h1"
//               sx={{
//                 fontFamily: "'Archivo Black', sans-serif",
//                 fontSize: {
//                   xs: "2rem",
//                   sm: "2.8rem",
//                   md: "3.5rem",
//                   lg: "4.1rem",
//                 },
//                 lineHeight: 1.15,
//                 marginBottom: { xs: "1rem", md: "1.5rem" },
//                 color: "#1A1A2E",
//                 wordBreak: "break-word",
//                 animation: "slideUp 0.8s ease-out",
//                 "@keyframes slideUp": {
//                   from: { opacity: 0, transform: "translateY(30px)" },
//                   to: { opacity: 1, transform: "translateY(0)" },
//                 },
//               }}
//             >
//               {/* Give Your Dealers a{" "} */}
//               Your End-to-End
//               <Box
//                 component="span"
//                 variant="h3"
//                 sx={{
//                   fontWeight: 800,
//                   color: "#0B4064",
//                   position: "relative",
//                   display: "inline-block",
//                 }}
//               >
//                 <GradientText> Technology Partner </GradientText> -
//               </Box>
//               We Build What Your Business Needs
//             </Typography>
//           </Zoom>

//           <Typography
//             component="p"
//             sx={{
//               fontSize: { xs: "1rem", sm: "1.1rem", md: "1.3rem" },
//               fontFamily: "'DM Sans', sans-serif",
//               lineHeight: 1.6,
//               marginBottom: { xs: "1.5rem", md: "2rem" },
//               color: "#2D3142",
//               opacity: 0.9,
//               animation: "slideUp 0.8s ease-out 0.2s both",
//               // Prevent text overflow on xs
//               wordBreak: "break-word",
//               overflowWrap: "break-word",
//             }}
//           >
//             {/* Stop the WhatsApp chaos. Get instant orders, faster payments, and
//             complete visibility into your dealer network—24/7. */}
//             Your trusted tech partner for Dealer & Distribution Apps, ERP
//             Solutions, and Custom Software Development. We engineer powerful,
//             custom technology for manufacturers, distributors, SMEs, and
//             startups.
//           </Typography>

//           {/* ── CTA Buttons ─────────────────────────────────────── */}
//           <Box
//             className="hero-buttons"
//             sx={{
//               display: "flex",
//               flexDirection: { xs: "column", sm: "row" },
//               gap: { xs: "0.875rem", sm: "1rem", md: "1.5rem" },
//               justifyContent: { xs: "center", lg: "flex-start" },
//               animation: "slideUp 0.8s ease-out 0.4s both",
//             }}
//           >
//             <Button
//               href="#pricing"
//               onClick={(e) => {
//                 e.preventDefault();
//                 scrollToSection("#pricing");
//               }}
//               sx={{
//                 background: "#2e9e53",
//                 color: "white",
//                 padding: { xs: "0.9rem 2rem", md: "1.2rem 2.5rem" },
//                 borderRadius: "50px",
//                 fontWeight: 700,
//                 fontSize: { xs: "1rem", md: "1.1rem" },
//                 transition: "all 0.3s",
//                 border: "2px solid #2e9e53",
//                 textTransform: "none",
//                 width: { xs: "100%", sm: "auto" },
//                 "&:hover": {
//                   background: "#2e9e53",
//                   transform: "translateY(-3px)",
//                   boxShadow: "0 10px 30px rgba(30, 163, 34, 0.3)",
//                 },
//               }}
//             >
//               {/* Start Free Trial */}
//               Start Your Journey
//             </Button>
//             <Button
//               component={Link}
//               to="/contact"
//               sx={{
//                 background: "white",
//                 color: "#2e9e53",
//                 padding: { xs: "0.9rem 2rem", md: "1.2rem 2.5rem" },
//                 borderRadius: "50px",
//                 fontWeight: 700,
//                 fontSize: { xs: "1rem", md: "1.1rem" },
//                 transition: "all 0.3s",
//                 border: "2px solid #2e9e53",
//                 textTransform: "none",
//                 width: { xs: "100%", sm: "auto" },
//                 "&:hover": {
//                   background: "#0B4064",
//                   border: "2px solid #0B4064",
//                   color: "white",
//                 },
//               }}
//             >
//               Schedule Demo
//             </Button>
//           </Box>

//           {/* ── Stats ───────────────────────────────────────────── */}
//           {/* <Box
//             className="hero-stats"
//             sx={{
//               display: "flex",
//               flexWrap: "wrap",
//               gap: { xs: "1.5rem", sm: "2rem", md: "3rem" },
//               marginTop: { xs: "2rem", md: "3rem" },
//               justifyContent: { xs: "center", lg: "flex-start" },
//               animation: "slideUp 0.8s ease-out 0.6s both",
//             }}
//           >
//             {[
//               { number: "15 Days", label: "Faster Payments" },
//               { number: "₹0", label: "Setup Fee" },
//               { number: "5min", label: "To Start" },
//             ].map((stat, index) => (
//               <Box key={index} sx={{ textAlign: "center", minWidth: "70px" }}>
//                 <Typography
//                   component="span"
//                   sx={{
//                     fontFamily: "'Archivo Black', sans-serif",
//                     fontSize: { xs: "1.8rem", sm: "2rem", md: "2.5rem" },
//                     color: "#0B4064",
//                     display: "block",
//                   }}
//                 >
//                   {stat.number}
//                 </Typography>
//                 <Typography
//                   component="span"
//                   sx={{
//                     fontSize: { xs: "0.75rem", md: "0.9rem" },
//                     color: "#2D3142",
//                     opacity: 0.7,
//                     textTransform: "uppercase",
//                     letterSpacing: "0.05em",
//                   }}
//                 >
//                   {stat.label}
//                 </Typography>
//               </Box>
//             ))}
//           </Box> */}
//         </Box>

//         {/* ── Phone Visual ────────────────────────────────────────────── */}
//         <Box
//           className="hero-visual"
//           sx={{
//             position: "relative",
//             animation: "fadeIn 1s ease-out 0.4s both",
//             display: "flex",
//             justifyContent: "center",
//             "@keyframes fadeIn": {
//               from: { opacity: 0 },
//               to: { opacity: 1 },
//             },
//           }}
//         >
//           <Box
//             className="phone-mockup"
//             sx={{
//               width: "100%",
//               maxWidth: { xs: "240px", sm: "300px", md: "360px", lg: "400px" },
//               margin: "0 auto",
//               position: "relative",
//               zIndex: 2,
//             }}
//           >
//             <Box
//               className="phone-frame"
//               sx={{
//                 background: "#1A1A2E",
//                 borderRadius: "40px",
//                 padding: "15px",
//                 boxShadow: "0 30px 60px rgba(0, 0, 0, 0.3)",
//                 transform: "rotate(-5deg)",
//                 transition: "transform 0.5s",
//                 "&:hover": {
//                   transform: "rotate(0deg) scale(1.05)",
//                 },
//               }}
//             >
//               <Box
//                 className="phone-screen"
//                 sx={{
//                   background: "white",
//                   borderRadius: "30px",
//                   overflow: "hidden",
//                   aspectRatio: "9/19.5",
//                 }}
//               >
//                 <Box
//                   className="app-preview"
//                   sx={{
//                     background:
//                       "linear-gradient(180deg, #0B4064 0%, #2e9e53 100%)",
//                     padding: { xs: "1.5rem 1rem", md: "2rem 1.5rem" },
//                     color: "white",
//                     height: "100%",
//                   }}
//                 >
//                   <Box sx={{ marginBottom: "1.5rem" }}>
//                     <Typography
//                       sx={{
//                         fontFamily: "'Archivo Black', sans-serif",
//                         fontSize: { xs: "1rem", md: "1.2rem" },
//                         marginBottom: "0.5rem",
//                       }}
//                     >
//                       BIZBRIDGE
//                     </Typography>
//                     <Typography sx={{ fontSize: "0.75rem", opacity: 0.9 }}>
//                       Dealer Portal
//                     </Typography>
//                   </Box>
//                   {[
//                     { label: "Outstanding", value: "₹3,45,000" },
//                     { label: "Orders This Month", value: "24 Orders" },
//                     { label: "Credit Available", value: "₹2,00,000" },
//                   ].map((item, index) => (
//                     <Box
//                       key={index}
//                       sx={{
//                         background: "rgba(255, 255, 255, 0.95)",
//                         borderRadius: "15px",
//                         padding: { xs: "0.75rem", md: "1rem" },
//                         marginBottom: "0.8rem",
//                         color: "#2D3142",
//                         boxShadow: "0 4px 15px rgba(0, 0, 0, 0.1)",
//                       }}
//                     >
//                       <Typography
//                         sx={{
//                           fontSize: "0.65rem",
//                           color: "#0B4064",
//                           textTransform: "uppercase",
//                           fontWeight: 700,
//                           letterSpacing: "0.05em",
//                           marginBottom: "0.3rem",
//                         }}
//                       >
//                         {item.label}
//                       </Typography>
//                       <Typography
//                         sx={{
//                           fontSize: { xs: "0.9rem", md: "1.1rem" },
//                           fontWeight: 700,
//                           color: "#1A1A2E",
//                         }}
//                       >
//                         {item.value}
//                       </Typography>
//                     </Box>
//                   ))}
//                 </Box>
//               </Box>
//             </Box>
//           </Box>
//         </Box>
//       </Box>
//     </Box>
//   );
// };

// export default Hero;

// import React from "react";
// import { Box, Typography, Button, Zoom } from "@mui/material";
// import { styled, keyframes } from "@mui/material/styles";
// import { Link } from "react-router-dom";
// import {
//   TrendingUp,
//   Inventory2,
//   Payments,
//   Assessment,
//   Speed,
//   SyncAlt,
// } from "@mui/icons-material";

// const shimmer = keyframes`
//   0% { background-position: -1000px 0; }
//   100% { background-position: 1000px 0; }
// `;

// const GradientText = styled("span")(({ theme }) => ({
//   background: "linear-gradient(135deg, #2E9E53 0%, #45B7A0 50%, #0B4064 100%)",
//   WebkitBackgroundClip: "text",
//   WebkitTextFillColor: "transparent",
//   fontWeight: "inherit",
//   backgroundSize: "200% 200%",
//   animation: `${shimmer} 3s ease-in-out infinite`,
// }));

// const Hero = () => {
//   const scrollToSection = (href) => {
//     const element = document.querySelector(href);
//     if (element) {
//       element.scrollIntoView({ behavior: "smooth" });
//     }
//   };

//   return (
//     <Box
//       component="section"
//       className="hero"
//       sx={{
//         marginTop: "80px",
//         minHeight: "90vh",
//         display: "flex",
//         alignItems: "center",
//         position: "relative",
//         overflow: "hidden",
//         background: "linear-gradient(135deg, #F7F7F7 0%, #E8F4F8 100%)",
//         "&::before": {
//           content: '""',
//           position: "absolute",
//           width: { xs: "300px", md: "600px" },
//           height: { xs: "300px", md: "600px" },
//           background:
//             "radial-gradient(circle, rgba(255, 107, 53, 0.1) 0%, transparent 70%)",
//           top: "-100px",
//           right: "-100px",
//           borderRadius: "50%",
//         },
//       }}
//     >
//       <Box
//         className="hero-content"
//         sx={{
//           width: "100%",
//           maxWidth: "1400px",
//           margin: "0 auto",
//           padding: { xs: "2rem 1.25rem", sm: "3rem 2rem", lg: "4rem 2rem" },
//           display: "grid",
//           gridTemplateColumns: { xs: "1fr", lg: "1.2fr 1fr" },
//           gap: { xs: "2.5rem", md: "4rem" },
//           alignItems: "center",
//           boxSizing: "border-box",
//         }}
//       >
//         {/* ── Text block ─────────────────────────────────────────────── */}
//         <Box
//           className="hero-text"
//           sx={{
//             textAlign: { xs: "center", lg: "left" },
//           }}
//         >
//           <Zoom in timeout={1000}>
//             <Typography
//               component="h1"
//               sx={{
//                 fontFamily: "'Archivo Black', sans-serif",
//                 fontSize: {
//                   xs: "2rem",
//                   sm: "2.8rem",
//                   md: "3.5rem",
//                   lg: "4.1rem",
//                 },
//                 lineHeight: 1.15,
//                 marginBottom: { xs: "1rem", md: "1.5rem" },
//                 color: "#1A1A2E",
//                 wordBreak: "break-word",
//                 animation: "slideUp 0.8s ease-out",
//                 "@keyframes slideUp": {
//                   from: { opacity: 0, transform: "translateY(30px)" },
//                   to: { opacity: 1, transform: "translateY(0)" },
//                 },
//               }}
//             >
//               Your End-to-End
//               <Box
//                 component="span"
//                 variant="h3"
//                 sx={{
//                   fontWeight: 800,
//                   color: "#0B4064",
//                   position: "relative",
//                   display: "inline-block",
//                 }}
//               >
//                 <GradientText> Technology Partner </GradientText> -
//               </Box>
//               We Build What Your Business Needs
//             </Typography>
//           </Zoom>

//           <Typography
//             component="p"
//             sx={{
//               fontSize: { xs: "1rem", sm: "1.1rem", md: "1.3rem" },
//               fontFamily: "'DM Sans', sans-serif",
//               lineHeight: 1.6,
//               marginBottom: { xs: "1.5rem", md: "2rem" },
//               color: "#2D3142",
//               opacity: 0.9,
//               animation: "slideUp 0.8s ease-out 0.2s both",
//               wordBreak: "break-word",
//               overflowWrap: "break-word",
//             }}
//           >
//             Your trusted tech partner for Dealer & Distribution Apps, ERP
//             Solutions, and Custom Software Development. We engineer powerful,
//             custom technology for manufacturers, distributors, SMEs, and
//             startups.
//           </Typography>

//           {/* ── CTA Buttons ─────────────────────────────────────── */}
//           <Box
//             className="hero-buttons"
//             sx={{
//               display: "flex",
//               flexDirection: { xs: "column", sm: "row" },
//               gap: { xs: "0.875rem", sm: "1rem", md: "1.5rem" },
//               justifyContent: { xs: "center", lg: "flex-start" },
//               animation: "slideUp 0.8s ease-out 0.4s both",
//             }}
//           >
//             <Button
//               href="#pricing"
//               onClick={(e) => {
//                 e.preventDefault();
//                 scrollToSection("#pricing");
//               }}
//               sx={{
//                 background: "#2e9e53",
//                 color: "white",
//                 padding: { xs: "0.9rem 2rem", md: "1.2rem 2.5rem" },
//                 borderRadius: "50px",
//                 fontWeight: 700,
//                 fontSize: { xs: "1rem", md: "1.1rem" },
//                 transition: "all 0.3s",
//                 border: "2px solid #2e9e53",
//                 textTransform: "none",
//                 width: { xs: "100%", sm: "auto" },
//                 "&:hover": {
//                   background: "#2e9e53",
//                   transform: "translateY(-3px)",
//                   boxShadow: "0 10px 30px rgba(30, 163, 34, 0.3)",
//                 },
//               }}
//             >
//               Start Your Journey
//             </Button>
//             <Button
//               component={Link}
//               to="/contact"
//               sx={{
//                 background: "white",
//                 color: "#2e9e53",
//                 padding: { xs: "0.9rem 2rem", md: "1.2rem 2.5rem" },
//                 borderRadius: "50px",
//                 fontWeight: 700,
//                 fontSize: { xs: "1rem", md: "1.1rem" },
//                 transition: "all 0.3s",
//                 border: "2px solid #2e9e53",
//                 textTransform: "none",
//                 width: { xs: "100%", sm: "auto" },
//                 "&:hover": {
//                   background: "#0B4064",
//                   border: "2px solid #0B4064",
//                   color: "white",
//                 },
//               }}
//             >
//               Schedule Demo
//             </Button>
//           </Box>
//         </Box>

//         {/* ── Phone Visual - ERP Dashboard Preview ────────────────── */}
//         <Box
//           className="hero-visual"
//           sx={{
//             position: "relative",
//             animation: "fadeIn 1s ease-out 0.4s both",
//             display: "flex",
//             justifyContent: "center",
//             "@keyframes fadeIn": {
//               from: { opacity: 0 },
//               to: { opacity: 1 },
//             },
//           }}
//         >
//           <Box
//             className="phone-mockup"
//             sx={{
//               width: "100%",
//               maxWidth: { xs: "240px", sm: "300px", md: "360px", lg: "400px" },
//               margin: "0 auto",
//               position: "relative",
//               zIndex: 2,
//             }}
//           >
//             <Box
//               className="phone-frame"
//               sx={{
//                 background: "#1A1A2E",
//                 borderRadius: "40px",
//                 padding: "15px",
//                 boxShadow: "0 30px 60px rgba(0, 0, 0, 0.3)",
//                 transform: "rotate(-5deg)",
//                 transition: "transform 0.5s",
//                 "&:hover": {
//                   transform: "rotate(0deg) scale(1.05)",
//                 },
//               }}
//             >
//               <Box
//                 className="phone-screen"
//                 sx={{
//                   background: "white",
//                   borderRadius: "30px",
//                   overflow: "hidden",
//                   aspectRatio: "9/19.5",
//                 }}
//               >
//                 <Box
//                   className="app-preview"
//                   sx={{
//                     background: "linear-gradient(180deg, #0B4064 0%, #2e9e53 100%)",
//                     padding: { xs: "1.5rem 1rem", md: "2rem 1.5rem" },
//                     color: "white",
//                     height: "100%",
//                     overflowY: "auto",
//                   }}
//                 >
//                   {/* Header */}
//                   <Box sx={{ marginBottom: "1.5rem", textAlign: "center" }}>
//                     <Typography
//                       sx={{
//                         fontFamily: "'Archivo Black', sans-serif",
//                         fontSize: { xs: "1rem", md: "1.2rem" },
//                         marginBottom: "0.25rem",
//                       }}
//                     >
//                       BIZBRIDGE
//                     </Typography>
//                     <Typography sx={{ fontSize: "0.65rem", opacity: 0.9 }}>
//                       ERP Dashboard
//                     </Typography>
//                   </Box>

//                   {/* KPI Cards */}
//                   <Box
//                     sx={{
//                       display: "grid",
//                       gridTemplateColumns: "1fr 1fr",
//                       gap: "0.6rem",
//                       marginBottom: "1rem",
//                     }}
//                   >
//                     <Box
//                       sx={{
//                         background: "rgba(255, 255, 255, 0.95)",
//                         borderRadius: "12px",
//                         padding: "0.6rem",
//                         textAlign: "center",
//                       }}
//                     >
//                       <TrendingUp sx={{ fontSize: "1rem", color: "#2e9e53" }} />
//                       <Typography
//                         sx={{
//                           fontSize: "0.5rem",
//                           color: "#0B4064",
//                           fontWeight: 700,
//                         }}
//                       >
//                         Revenue
//                       </Typography>
//                       <Typography
//                         sx={{
//                           fontSize: "0.8rem",
//                           fontWeight: 700,
//                           color: "#1A1A2E",
//                         }}
//                       >
//                         ₹12.4L
//                       </Typography>
//                       <Typography sx={{ fontSize: "0.45rem", color: "#2e9e53" }}>
//                         +23%
//                       </Typography>
//                     </Box>
//                     <Box
//                       sx={{
//                         background: "rgba(255, 255, 255, 0.95)",
//                         borderRadius: "12px",
//                         padding: "0.6rem",
//                         textAlign: "center",
//                       }}
//                     >
//                       <Inventory2 sx={{ fontSize: "1rem", color: "#2e9e53" }} />
//                       <Typography
//                         sx={{
//                           fontSize: "0.5rem",
//                           color: "#0B4064",
//                           fontWeight: 700,
//                         }}
//                       >
//                         Stock Value
//                       </Typography>
//                       <Typography
//                         sx={{
//                           fontSize: "0.8rem",
//                           fontWeight: 700,
//                           color: "#1A1A2E",
//                         }}
//                       >
//                         ₹8.2L
//                       </Typography>
//                       <Typography sx={{ fontSize: "0.45rem", color: "#ff6b35" }}>
//                         -5%
//                       </Typography>
//                     </Box>
//                   </Box>

//                   {/* Main Stats */}
//                   {[
//                     { label: "Total Orders (MTD)", value: "156", icon: <Assessment sx={{ fontSize: "0.7rem" }} /> },
//                     { label: "Avg. Collection Days", value: "18 Days", icon: <Payments sx={{ fontSize: "0.7rem" }} /> },
//                     { label: "Open Invoices", value: "₹4,25,000", icon: <Payments sx={{ fontSize: "0.7rem" }} /> },
//                     { label: "Inventory Turnover", value: "4.2x", icon: <SyncAlt sx={{ fontSize: "0.7rem" }} /> },
//                   ].map((item, index) => (
//                     <Box
//                       key={index}
//                       sx={{
//                         background: "rgba(255, 255, 255, 0.95)",
//                         borderRadius: "12px",
//                         padding: { xs: "0.6rem 0.8rem", md: "0.75rem 1rem" },
//                         marginBottom: "0.6rem",
//                         display: "flex",
//                         alignItems: "center",
//                         justifyContent: "space-between",
//                       }}
//                     >
//                       <Box sx={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
//                         <Box sx={{ color: "#2e9e53" }}>{item.icon}</Box>
//                         <Typography
//                           sx={{
//                             fontSize: "0.6rem",
//                             color: "#0B4064",
//                             fontWeight: 600,
//                             letterSpacing: "0.03em",
//                           }}
//                         >
//                           {item.label}
//                         </Typography>
//                       </Box>
//                       <Typography
//                         sx={{
//                           fontSize: "0.75rem",
//                           fontWeight: 700,
//                           color: "#1A1A2E",
//                         }}
//                       >
//                         {item.value}
//                       </Typography>
//                     </Box>
//                   ))}

//                   {/* Progress Bar */}
//                   <Box
//                     sx={{
//                       background: "rgba(255, 255, 255, 0.95)",
//                       borderRadius: "12px",
//                       padding: "0.6rem 0.8rem",
//                       marginTop: "0.5rem",
//                     }}
//                   >
//                     <Typography
//                       sx={{
//                         fontSize: "0.55rem",
//                         color: "#0B4064",
//                         fontWeight: 600,
//                         marginBottom: "0.3rem",
//                       }}
//                     >
//                       Monthly Target Achievement
//                     </Typography>
//                     <Box
//                       sx={{
//                         background: "#E0E0E0",
//                         borderRadius: "10px",
//                         height: "6px",
//                         overflow: "hidden",
//                       }}
//                     >
//                       <Box
//                         sx={{
//                           width: "78%",
//                           background: "#2e9e53",
//                           height: "100%",
//                           borderRadius: "10px",
//                         }}
//                       />
//                     </Box>
//                     <Typography
//                       sx={{
//                         fontSize: "0.55rem",
//                         color: "#2e9e53",
//                         fontWeight: 700,
//                         marginTop: "0.3rem",
//                         textAlign: "right",
//                       }}
//                     >
//                       78% Complete
//                     </Typography>
//                   </Box>
//                 </Box>
//               </Box>
//             </Box>
//           </Box>
//         </Box>
//       </Box>
//     </Box>
//   );
// };

// export default Hero;

import React from "react";
import { Box, Typography, Button, Zoom } from "@mui/material";
import { styled, keyframes } from "@mui/material/styles";
import { Link } from "react-router-dom";
import {
  TrendingUp,
  Inventory2,
  Payments,
  Assessment,
  Speed,
  SyncAlt,
} from "@mui/icons-material";

const shimmer = keyframes`
  0% { background-position: -1000px 0; }
  100% { background-position: 1000px 0; }
`;

const GradientText = styled("span")(({ theme }) => ({
  background: "linear-gradient(135deg, #2E9E53 0%, #45B7A0 50%, #0B4064 100%)",
  WebkitBackgroundClip: "text",
  WebkitTextFillColor: "transparent",
  fontWeight: "inherit",
  backgroundSize: "200% 200%",
  animation: `${shimmer} 3s ease-in-out infinite`,
}));

const Hero = () => {
  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <Box
      component="section"
      className="hero"
      sx={{
        marginTop: "80px",
        minHeight: "90vh",
        display: "flex",
        alignItems: "center",
        position: "relative",
        overflow: "hidden",
        background: "linear-gradient(135deg, #F7F7F7 0%, #E8F4F8 100%)",
        "&::before": {
          content: '""',
          position: "absolute",
          width: { xs: "300px", md: "600px" },
          height: { xs: "300px", md: "600px" },
          background:
            "radial-gradient(circle, rgba(255, 107, 53, 0.1) 0%, transparent 70%)",
          top: "-100px",
          right: "-100px",
          borderRadius: "50%",
        },
      }}
    >
      <Box
        className="hero-content"
        sx={{
          width: "100%",
          maxWidth: "1400px",
          margin: "0 auto",
          padding: { xs: "2rem 1.25rem", sm: "3rem 2rem", lg: "4rem 2rem" },
          display: "grid",
          gridTemplateColumns: { xs: "1fr", lg: "1.2fr 1fr" },
          gap: { xs: "2.5rem", md: "4rem" },
          alignItems: "center",
          boxSizing: "border-box",
        }}
      >
        {/* ── Text block ─────────────────────────────────────────────── */}
        <Box
          className="hero-text"
          sx={{
            textAlign: { xs: "center", lg: "left" },
          }}
        >
          <Zoom in timeout={1000}>
            <Typography
              component="h1"
              sx={{
                fontFamily: "'Archivo Black', sans-serif",
                fontSize: {
                  xs: "2rem",
                  sm: "2.8rem",
                  md: "3.5rem",
                  lg: "4.1rem",
                },
                lineHeight: 1.15,
                marginBottom: { xs: "1rem", md: "1.5rem" },
                color: "#1A1A2E",
                wordBreak: "break-word",
                animation: "slideUp 0.8s ease-out",
                "@keyframes slideUp": {
                  from: { opacity: 0, transform: "translateY(30px)" },
                  to: { opacity: 1, transform: "translateY(0)" },
                },
              }}
            >
              Your End-to-End
              <Box
                component="span"
                variant="h3"
                sx={{
                  fontWeight: 800,
                  color: "#0B4064",
                  position: "relative",
                  display: "inline-block",
                }}
              >
                <GradientText> Technology Partner </GradientText> -
              </Box>
              We Build What Your Business Needs
            </Typography>
          </Zoom>

          <Typography
            component="p"
            sx={{
              fontSize: { xs: "1rem", sm: "1.1rem", md: "1.3rem" },
              fontFamily: "'DM Sans', sans-serif",
              lineHeight: 1.6,
              marginBottom: { xs: "1.5rem", md: "2rem" },
              color: "#2D3142",
              opacity: 0.9,
              animation: "slideUp 0.8s ease-out 0.2s both",
              wordBreak: "break-word",
              overflowWrap: "break-word",
            }}
          >
            Your trusted tech partner for Dealer & Distribution Apps, ERP
            Solutions, and Custom Software Development. We engineer powerful,
            custom technology for manufacturers, distributors, SMEs, and
            startups.
          </Typography>

          {/* ── CTA Buttons ─────────────────────────────────────── */}
          <Box
            className="hero-buttons"
            sx={{
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              gap: { xs: "0.875rem", sm: "1rem", md: "1.5rem" },
              justifyContent: { xs: "center", lg: "flex-start" },
              animation: "slideUp 0.8s ease-out 0.4s both",
            }}
          >
            <Button
              href="#pricing"
              onClick={(e) => {
                e.preventDefault();
                scrollToSection("#pricing");
              }}
              sx={{
                background: "#2e9e53",
                color: "white",
                padding: { xs: "0.9rem 2rem", md: "1.2rem 2.5rem" },
                borderRadius: "50px",
                fontWeight: 700,
                fontSize: { xs: "1rem", md: "1.1rem" },
                transition: "all 0.3s",
                border: "2px solid #2e9e53",
                textTransform: "none",
                width: { xs: "100%", sm: "auto" },
                "&:hover": {
                  background: "#2e9e53",
                  transform: "translateY(-3px)",
                  boxShadow: "0 10px 30px rgba(30, 163, 34, 0.3)",
                },
              }}
            >
              Start Your Journey
            </Button>
            <Button
              component={Link}
              to="/contact"
              sx={{
                background: "white",
                color: "#2e9e53",
                padding: { xs: "0.9rem 2rem", md: "1.2rem 2.5rem" },
                borderRadius: "50px",
                fontWeight: 700,
                fontSize: { xs: "1rem", md: "1.1rem" },
                transition: "all 0.3s",
                border: "2px solid #2e9e53",
                textTransform: "none",
                width: { xs: "100%", sm: "auto" },
                "&:hover": {
                  background: "#0B4064",
                  border: "2px solid #0B4064",
                  color: "white",
                },
              }}
            >
              Schedule Demo
            </Button>
          </Box>
        </Box>

        {/* ── Phone Visual - ERP Dashboard with Charts ────────────────── */}
        <Box
          className="hero-visual"
          sx={{
            position: "relative",
            animation: "fadeIn 1s ease-out 0.4s both",
            display: "flex",
            justifyContent: "center",
            "@keyframes fadeIn": {
              from: { opacity: 0 },
              to: { opacity: 1 },
            },
          }}
        >
          <Box
            className="phone-mockup"
            sx={{
              width: "100%",
              maxWidth: { xs: "240px", sm: "300px", md: "360px", lg: "400px" },
              margin: "0 auto",
              position: "relative",
              zIndex: 2,
            }}
          >
            <Box
              className="phone-frame"
              sx={{
                background: "#1A1A2E",
                borderRadius: "40px",
                padding: "15px",
                boxShadow: "0 30px 60px rgba(0, 0, 0, 0.3)",
                transform: "rotate(-5deg)",
                transition: "transform 0.5s",
                "&:hover": {
                  transform: "rotate(0deg) scale(1.05)",
                },
              }}
            >
              <Box
                className="phone-screen"
                sx={{
                  background: "white",
                  borderRadius: "30px",
                  overflow: "hidden",
                  overflowY: "auto",
                  aspectRatio: "9/19.5",
                }}
              >
                <Box
                  className="app-preview"
                  sx={{
                    background: "linear-gradient(180deg, #0B4064 0%, #2e9e53 100%)",
                    padding: { xs: "1.2rem 0.8rem", md: "1.5rem 1rem" },
                    color: "white",
                    minHeight: "100%",
                  }}
                >
                  {/* Header */}
                  <Box sx={{ marginBottom: "1rem", textAlign: "center" }}>
                    <Typography
                      sx={{
                        fontFamily: "'Archivo Black', sans-serif",
                        fontSize: { xs: "0.9rem", md: "1rem" },
                        marginBottom: "0.2rem",
                      }}
                    >
                      BIZBRIDGE
                    </Typography>
                    <Typography sx={{ fontSize: "0.55rem", opacity: 0.9 }}>
                      ERP Dashboard
                    </Typography>
                  </Box>

                  {/* Line Chart - Monthly Revenue Trend */}
                  <Box
                    sx={{
                      background: "rgba(255, 255, 255, 0.95)",
                      borderRadius: "12px",
                      padding: "0.6rem",
                      marginBottom: "0.8rem",
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: "0.55rem",
                        color: "#0B4064",
                        fontWeight: 700,
                        marginBottom: "0.5rem",
                      }}
                    >
                      Monthly Revenue (₹ Lakhs)
                    </Typography>
                    <svg width="100%" height="70" viewBox="0 0 300 70" preserveAspectRatio="none">
                      <polyline
                        points="10,50 50,40 90,30 130,45 170,25 210,35 250,20 290,30"
                        fill="none"
                        stroke="#2e9e53"
                        strokeWidth="2"
                      />
                      <circle cx="10" cy="50" r="2.5" fill="#2e9e53" />
                      <circle cx="50" cy="40" r="2.5" fill="#2e9e53" />
                      <circle cx="90" cy="30" r="2.5" fill="#2e9e53" />
                      <circle cx="130" cy="45" r="2.5" fill="#2e9e53" />
                      <circle cx="170" cy="25" r="2.5" fill="#2e9e53" />
                      <circle cx="210" cy="35" r="2.5" fill="#2e9e53" />
                      <circle cx="250" cy="20" r="2.5" fill="#2e9e53" />
                      <circle cx="290" cy="30" r="2.5" fill="#2e9e53" />
                    </svg>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        mt: 0.5,
                        px: 0.5,
                      }}
                    >
                      {["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug"].map(
                        (month, i) => (
                          <Typography
                            key={i}
                            sx={{ fontSize: "0.4rem", color: "#666" }}
                          >
                            {month}
                          </Typography>
                        )
                      )}
                    </Box>
                  </Box>

                  {/* KPI Cards Row */}
                  <Box
                    sx={{
                      display: "grid",
                      gridTemplateColumns: "1fr 1fr",
                      gap: "0.5rem",
                      marginBottom: "0.8rem",
                    }}
                  >
                    <Box
                      sx={{
                        background: "rgba(255, 255, 255, 0.95)",
                        borderRadius: "10px",
                        padding: "0.5rem",
                        textAlign: "center",
                      }}
                    >
                      <TrendingUp sx={{ fontSize: "0.8rem", color: "#2e9e53" }} />
                      <Typography
                        sx={{ fontSize: "0.45rem", color: "#0B4064", fontWeight: 700 }}
                      >
                        Revenue
                      </Typography>
                      <Typography
                        sx={{ fontSize: "0.7rem", fontWeight: 700, color: "#1A1A2E" }}
                      >
                        ₹12.4L
                      </Typography>
                      <Typography sx={{ fontSize: "0.4rem", color: "#2e9e53" }}>
                        +23%
                      </Typography>
                    </Box>
                    <Box
                      sx={{
                        background: "rgba(255, 255, 255, 0.95)",
                        borderRadius: "10px",
                        padding: "0.5rem",
                        textAlign: "center",
                      }}
                    >
                      <Inventory2 sx={{ fontSize: "0.8rem", color: "#2e9e53" }} />
                      <Typography
                        sx={{ fontSize: "0.45rem", color: "#0B4064", fontWeight: 700 }}
                      >
                        Stock Value
                      </Typography>
                      <Typography
                        sx={{ fontSize: "0.7rem", fontWeight: 700, color: "#1A1A2E" }}
                      >
                        ₹8.2L
                      </Typography>
                      <Typography sx={{ fontSize: "0.4rem", color: "#ff6b35" }}>
                        -5%
                      </Typography>
                    </Box>
                  </Box>

                  {/* Bar Chart - Category Sales */}
                  <Box
                    sx={{
                      background: "rgba(255, 255, 255, 0.95)",
                      borderRadius: "12px",
                      padding: "0.6rem",
                      marginBottom: "0.8rem",
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: "0.55rem",
                        color: "#0B4064",
                        fontWeight: 700,
                        marginBottom: "0.5rem",
                      }}
                    >
                      Sales by Category
                    </Typography>
                    <Box sx={{ display: "flex", gap: "0.4rem", alignItems: "flex-end", height: "50px" }}>
                      <Box sx={{ flex: 1, textAlign: "center" }}>
                        <Box
                          sx={{
                            height: "35px",
                            background: "#2e9e53",
                            borderRadius: "4px",
                            width: "100%",
                          }}
                        />
                        <Typography sx={{ fontSize: "0.4rem", mt: 0.3, color: "#666" }}>
                          Electronics
                        </Typography>
                      </Box>
                      <Box sx={{ flex: 1, textAlign: "center" }}>
                        <Box
                          sx={{
                            height: "25px",
                            background: "#45B7A0",
                            borderRadius: "4px",
                            width: "100%",
                          }}
                        />
                        <Typography sx={{ fontSize: "0.4rem", mt: 0.3, color: "#666" }}>
                          Apparel
                        </Typography>
                      </Box>
                      <Box sx={{ flex: 1, textAlign: "center" }}>
                        <Box
                          sx={{
                            height: "40px",
                            background: "#0B4064",
                            borderRadius: "4px",
                            width: "100%",
                          }}
                        />
                        <Typography sx={{ fontSize: "0.4rem", mt: 0.3, color: "#666" }}>
                          Grocery
                        </Typography>
                      </Box>
                      <Box sx={{ flex: 1, textAlign: "center" }}>
                        <Box
                          sx={{
                            height: "20px",
                            background: "#ff6b35",
                            borderRadius: "4px",
                            width: "100%",
                          }}
                        />
                        <Typography sx={{ fontSize: "0.4rem", mt: 0.3, color: "#666" }}>
                          Furniture
                        </Typography>
                      </Box>
                    </Box>
                  </Box>

                  {/* Donut/Pie Chart Placeholder - Payment Collection */}
                  <Box
                    sx={{
                      background: "rgba(255, 255, 255, 0.95)",
                      borderRadius: "12px",
                      padding: "0.6rem",
                      marginBottom: "0.8rem",
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: "0.55rem",
                        color: "#0B4064",
                        fontWeight: 700,
                        marginBottom: "0.5rem",
                        textAlign: "center",
                      }}
                    >
                      Payment Collection
                    </Typography>
                    <Box sx={{ display: "flex", alignItems: "center", gap: "0.8rem" }}>
                      {/* Simple Donut Chart using SVG */}
                      <svg width="50" height="50" viewBox="0 0 40 40">
                        <circle cx="20" cy="20" r="16" fill="none" stroke="#E0E0E0" strokeWidth="6" />
                        <circle
                          cx="20"
                          cy="20"
                          r="16"
                          fill="none"
                          stroke="#2e9e53"
                          strokeWidth="6"
                          strokeDasharray="75.4"
                          strokeDashoffset="22.6"
                          strokeLinecap="round"
                          transform="rotate(-90 20 20)"
                        />
                        <text x="20" y="24" textAnchor="middle" fontSize="6" fill="#1A1A2E" fontWeight="bold">
                          70%
                        </text>
                      </svg>
                      <Box sx={{ flex: 1 }}>
                        <Box sx={{ display: "flex", alignItems: "center", gap: "0.3rem", mb: 0.3 }}>
                          <Box sx={{ width: "6px", height: "6px", borderRadius: "50%", background: "#2e9e53" }} />
                          <Typography sx={{ fontSize: "0.45rem", color: "#666" }}>Collected: ₹8.7L</Typography>
                        </Box>
                        <Box sx={{ display: "flex", alignItems: "center", gap: "0.3rem" }}>
                          <Box sx={{ width: "6px", height: "6px", borderRadius: "50%", background: "#E0E0E0" }} />
                          <Typography sx={{ fontSize: "0.45rem", color: "#666" }}>Pending: ₹3.7L</Typography>
                        </Box>
                      </Box>
                    </Box>
                  </Box>

                  {/* Info Cards */}
                  {[
                    { label: "Total Orders (MTD)", value: "156", icon: <Assessment sx={{ fontSize: "0.6rem" }} /> },
                    { label: "Avg. Collection Days", value: "18 Days", icon: <Payments sx={{ fontSize: "0.6rem" }} /> },
                  ].map((item, index) => (
                    <Box
                      key={index}
                      sx={{
                        background: "rgba(255, 255, 255, 0.95)",
                        borderRadius: "10px",
                        padding: "0.5rem 0.7rem",
                        marginBottom: "0.5rem",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      <Box sx={{ display: "flex", alignItems: "center", gap: "0.4rem" }}>
                        <Box sx={{ color: "#2e9e53" }}>{item.icon}</Box>
                        <Typography
                          sx={{
                            fontSize: "0.5rem",
                            color: "#0B4064",
                            fontWeight: 600,
                          }}
                        >
                          {item.label}
                        </Typography>
                      </Box>
                      <Typography
                        sx={{
                          fontSize: "0.65rem",
                          fontWeight: 700,
                          color: "#1A1A2E",
                        }}
                      >
                        {item.value}
                      </Typography>
                    </Box>
                  ))}
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default Hero;